import classNames from 'classnames'
import React from 'react'
import * as Reakit from 'reakit/Tab'

import { useTabsContext } from './tabs'

type TabListProps = {
  'aria-label': string
  className?: string
}

export function TabList({ 'aria-label': ariaLabel, className, children }: React.PropsWithChildren<TabListProps>) {
  const state = useTabsContext()

  return (
    <Reakit.TabList
      {...state}
      aria-label={ariaLabel}
      className={classNames('flex shadow-[inset_0_-1px_0] shadow-gray-100 dark:shadow-gray-700', className)}
    >
      {children}
    </Reakit.TabList>
  )
}
